import axios from "axios";
import Config from "src/config";

const v2_actionSendAnalysisFeedback = (analysisId, data) => {
    return axios({
        method: "PUT",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/ai/${analysisId}/feedback`,
        data
    });
};

export default v2_actionSendAnalysisFeedback; 